import { Stack, StackItem, Text } from '@fluentui/react';
import React, { useCallback, useMemo } from 'react';
import downloadIcon from '../../../assets/icons/svg/download.svg';
import { useDocumentsManager } from '../../../contexts/documentContext';
import { saveToComputer } from '../../../helpers';
import SvgIcon from '../../SvgIcon';

const Attachment = (props) => {

    const {
        fileName = undefined,
        rowGUID = undefined,
        searchedValue = undefined,
    } = props;

    const { getFileData, markAsRead } = useDocumentsManager();

    const styles = useMemo(
        () => {
            let styles = {
                attachment: {
                    root: {
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 5,
                        selectors: {
                            ":hover": { cursor: "pointer" },
                            ":hover > span": { color: "red" }
                        }
                    }
                },
                fileName: {
                    root: {
                        color: "#777777",
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: "16px",
                        marginBottom: -4,
                        wordBreak: "break-word"
                    }
                },
                highlighted: {
                    root: {
                        backgroundColor: "yellow",
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: "16px",
                        marginBottom: -4,
                        wordBreak: "break-word"
                    }
                },
            };

            return styles;
        },
        []
    );

    const fileNameWithHighlight = useMemo(() => {
        if (!fileName) return;
        else if (!searchedValue || searchedValue.length <= 2) return <Text styles={styles.fileName}>{fileName}</Text>
        else {
            const regex = new RegExp(`(${searchedValue})`, "gi");
            return <StackItem>
                {fileName.split(regex).filter(part => !!part).map((part, index) => {
                    const dataHighlighted = part.toLowerCase() === searchedValue.toLowerCase();
                    const style = dataHighlighted ? styles.highlighted : styles.fileName;
                    return <Text key={index} styles={style} data-highlighted={dataHighlighted}>{part}</Text>
                })}
            </StackItem>;
        }
    }, [fileName, searchedValue, styles]);

    const download = useCallback(async () => {
        const document = { rowGUID };
        const fileData = await getFileData(document);
        markAsRead(document);
        saveToComputer(fileData, fileName);
    }, [fileName, getFileData, markAsRead, rowGUID]);

    return <Stack onClick={event => download()} styles={styles.attachment}>
        <SvgIcon
            height={12}
            src={downloadIcon}
            title="Télécharger"
        />
        {fileNameWithHighlight}
    </Stack>;

};

export default Attachment;